import { FormsModule } from '@angular/forms';
import { IconDefinition } from '@fortawesome/fontawesome-svg-core';
import { TranslocoLocaleModule } from '@ngneat/transloco-locale';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { IonicModule } from '@ionic/angular';
import { PageLayoutComponent } from './page-layout.component';
import { FaIconLibrary, FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import { SharedUiThemingModule } from '@tcc-mono/shared/ui/theming';
import { RouterModule } from '@angular/router';

import {
  faBars,
  faHouseWindow,
  faChevronRight,
  faFilters,
  faEllipsisVertical,
  faPlusLarge,
} from '@fortawesome/pro-light-svg-icons';


import { SubscribeDirective } from '@ngneat/subscribe';
import { TranslocoModule } from '@ngneat/transloco';
import { PropertyCountPipe } from './property-count.pipe';

const icons: IconDefinition[] = [
  faBars,
  faHouseWindow,
  faChevronRight,
  faFilters,
  faEllipsisVertical,
  faPlusLarge,
]

@NgModule({
  imports: [
    CommonModule,
    IonicModule,
    FontAwesomeModule,
    SharedUiThemingModule,
    TranslocoLocaleModule,
    RouterModule,
    FormsModule,
    SubscribeDirective
  ],
  declarations: [
    PageLayoutComponent,
    PropertyCountPipe
  ],
  exports: [
    PageLayoutComponent
  ]
})
export class PageLayoutModule {
  constructor(
    lib: FaIconLibrary
  ) {
    lib.addIcons(...icons);
  }
}
